import React, { useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import WidgetCard, { Widget } from "./WidgetCard";
import './styles/widget-container.scss';
import { useSelector } from "react-redux";

interface IProps {
  data: Widget[];
  setSelectedTab: (selectedTab: string) => void;
  deleteproduct: (id: string) => void;
  handleWidgetStatus: (widgetId: string, status: boolean) => void;
}

const WidgetContainer: React.FC<IProps> = ({ data, setSelectedTab, deleteproduct, handleWidgetStatus }) => {
  const match: any = useRouteMatch();

  const currentUserId = useSelector((state: any) => state.user.data.user.id)

  useEffect(() => {
    const pathSegments = match.path.split("/");
    if (pathSegments.length) {
      const selectedTab = pathSegments[pathSegments.length - 1];
      setSelectedTab(selectedTab);
    }
  }, [match.path, setSelectedTab]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-7 widget-container">
      {data.map((el: any) => {
        return <WidgetCard data-test-id={`${el.id}`} key={el.id} widget={el}
          deleteproduct={deleteproduct} handleWidgetStatus={handleWidgetStatus} editAccess={el.user_id === currentUserId} />;
      })}
    </div>
  );
};

export default WidgetContainer;
